import { isNumber } from 'utils/validators';

const SCHEDULE_PASS_NAME = 'schedulePassForm';

const validate = values => {
  const errors = {};

  if (isNumber(values.activity, true)) {
    errors.activity = 'Activity is required';
  }

  if (
    values.scheduleType !== SCHEDULE_PASS_NAME &&
    !values.startingDate &&
    (!values.multiDates?.startDate || !values?.multiDates.endDate)
  ) {
    errors.startingDate = 'Starting date is required';
    errors.multiDates = 'Starting date is required';
  }

  if (values.participants && values.participants.length) {
    let participantsArrayErrors = [];
    let isValidParticipants = false;

    values.participants.forEach((item, index) => {
      if (item.participants && parseInt(item.participants) > 0) {
        isValidParticipants = true;
      }

      participantsArrayErrors[index] = { participants: 'Error' };
    });

    if (!isValidParticipants) {
      errors.participants = {
        ...participantsArrayErrors,
        _error: 'Value for at least one category should be filled in'
      };
    }
  }

  if (
    !errors.participants &&
    values.participants &&
    values.participants.length
  ) {
    const availableParticipants = values.maxParticipants;
    const participantsArrayErrors = [];
    let totalParticipants = 0;

    values.participants.forEach((item, index) => {
      if (item.participants && item.participants.length) {
        totalParticipants += parseInt(item.participants);
      }
      participantsArrayErrors[index] = { participants: 'Error' };
    });

    if (totalParticipants > availableParticipants) {
      errors.participants = {
        ...participantsArrayErrors,
        _error: `The number of Guests can’t exceed ${availableParticipants}`
      };
    }
  }

  return errors;
};

export default validate;
